import "./SearchComponent.scss";
import React from "react";
import { routesMap } from "../../routes";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * @function SearchComponent Search components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const SearchComponent = () => {
    const navigate = useNavigate();
    const [inputVal, setInputVal] = React.useState(""); 

    const { state } = useLocation();
    const location = useLocation();

    React.useEffect(() => {
        if(location?.pathname && location?.pathname !== routesMap.SEARCH_PAGE) {
            setInputVal("")
        } else {
            if(state?.keyword) setInputVal(state?.keyword);
        }
    }, [location]);

    const setInput = (value) => {
        setInputVal(value);
    }

    const doResearch = (inputVal, code) => {
        console.log(code)
        if (code === "Enter" || code === "NumpadEnter") {
            //redirect alla pagina della ricerca
            navigate(routesMap.SEARCH_PAGE, { state: { keyword: inputVal, page: 0 } });
        }
    }
    

    return (
        <div className="form-group">
            <input type="search" className="search" value={inputVal} onChange={ e => setInput(e.target.value) } placeholder="Cerca" onKeyDown={ e => doResearch(inputVal, e.code)}></input>
            <span className="autocomplete-icon material-icons" aria-hidden="true">{ inputVal === "" ? "search" : "" }</span>
        </div>
    )
};

export default SearchComponent;